export default __webpack_public_path__ + "static/media/tutorial_preview_commonroad_interface_2.fa5f54ce.png";